import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {Network} from "../../../network/Network";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {ProductType} from "../../../models/product/ProductType";
import {IAccountChannelIncoming} from "../../../models/account/channel/IAccountChannelIncoming";

export class AccountChannelService {

    public static dispose(): void {
    }

    public static init(): void {
    }

    /**
     * rest
     */
    public static async findAll(component?: INetworkComponent): Promise<IAccountChannelIncoming[]> {
        const request = await Network.get(ProductType.PANEL, "/account/channels", component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
        return [];
    }

    public static async remove(id: string, component?: INetworkComponent): Promise<boolean> {
        const request = await Network.post(ProductType.PANEL, "/account/channel/remove", {id: id}, component);
        return request.status == HttpStatus.OK;
    }
}
